import React from 'react';
import Title from './Title';
import './Section.css';

function Section(props) {
    return (
        <div className="section">
            <div className='row'>
                <div className='rowItem'>
                    <Title value={props.title} link={props.link}/>
                    <div className='short-divider'></div>
                    <p className='description'>{props.description}</p>
                </div>
                { props.img &&
                    <div className='rowItem'>
                        <img src={props.img}/>
                    </div>  
                }
            </div>
        </div>
    )
}

export default Section;